import { motion } from "framer-motion";
import { Reveal, LineReveal } from "./primitives";
import { CONTACT } from "@/data/content";
import { ArrowUpRight, Mail, FileDown } from "lucide-react";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="py-24 md:py-36 bg-[#101010] text-[#f5f3ef]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#e24a29]">Contact</span>
      </Reveal>

      <div className="mt-8 font-display font-black tracking-tighter leading-[0.9] text-[16vw] md:text-[13vw] lg:text-[11vw]">
        <LineReveal delay={0.05}>Let&apos;s talk.</LineReveal>
      </div>

      <div className="mt-10 grid lg:grid-cols-[1.2fr_1fr] gap-10 items-end">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-lg md:text-xl text-[#a8a29e] max-w-xl leading-relaxed"
        >
          Hiring for a social, GTM or performance role? I&apos;m open to work with D2C brands, startups and agencies.
          Tell me what outcome you&apos;re chasing.
        </motion.p>

        <div className="flex flex-wrap gap-3 lg:justify-end">
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="contact-email-btn"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-[#e24a29] text-white font-semibold hover:bg-[#f5f3ef] hover:text-[#101010] transition-colors duration-300"
          >
            <Mail size={18} /> {CONTACT.email}
          </a>
          <a
            href={CONTACT.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-linkedin-btn"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-white/25 font-semibold hover:bg-white/10 transition-colors duration-300"
          >
            LinkedIn <ArrowUpRight size={18} />
          </a>
          <a
            href={CONTACT.resume}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-resume-btn"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-white/25 font-semibold hover:bg-white/10 transition-colors duration-300"
          >
            <FileDown size={18} /> Download résumé
          </a>
        </div>
      </div>

      <div className="mt-24 pt-8 border-t border-white/12 flex flex-wrap items-center justify-between gap-4 text-sm text-[#a8a29e]">
        <span className="font-display font-bold text-[#f5f3ef]">Aditya Rajawat</span>
        <span>Marketer · Social, GTM &amp; Performance</span>
        <span>© {new Date().getFullYear()} — Built to earn the click.</span>
      </div>
    </div>
  </section>
);
